import angular from 'angular';

import templateUrl from './rs-payout-transfers-list.component.html';

export const RsPayoutTransfersListComponent = {
    controller: RsPayoutTransfersListController,
    controllerAs: "vm",
    templateUrl,
    bindings: {
        rsPayoutTransfers: "<",
        totalsPayoutTransfers: "<"
    }
};

function RsPayoutTransfersListController(utilityService, rsPayoutTransfersService) {
    'ngInject';
    const vm = this;

    vm.$onInit = activate;

    vm.columns;
    vm.sortColumns = [{ field: "EffectiveDate", dir: -1 }]; // Default
    vm.isSortingByField = isSortingByField;
    vm.columnClass = columnClass
    vm.pageNumber = 1;
    vm.pageSize = 5;
    vm.onSetSort = onSetSort;
    vm.sortTransfers = sortTransfers;
    vm.rsPayoutTransfers = [];
    vm.prestineRsPayoutTransfers = [];
    vm.totalsPayoutTransfers;
    vm.selected;
    vm.deleteTransfer = deleteTransfer;
    vm.resetTransfer = resetTransfer;
    vm.editTransfer = editTransfer;
    vm.updateTransfer = updateTransfer;
    vm.pristineRsPayoutTransfers = vm.rsPayoutTransfers;
    vm.onChangeAmount = onChangeAmount;
    vm.$onChanges = $onChanges;
    function activate() {
        vm.columns = [

            {
                title: "Program",
                field: "ProgramName",
                sortable: true
            },
            {
                title: "Retailer",
                field: "RetailerName",
                sortable: true
            },
            {
                title: "Store #",
                field: "StoreName",
                sortable: true
            }
            ,
            {
                title: "From",
                field: "FromIcdCorporationName",
                sortable: true
            },
            {
                title: "To",
                field: "ToIcdCorporationName",
                sortable: true
            },
            {
                title: "Amount",
                field: "Amount",
                sortable: true
            },
            {
                title: "Effective Date",
                field: "EffectiveDate",
                sortable: true
            }
        ];

        vm.rsPayoutTransfers.forEach(function (transfer) {
            transfer.editMode = false;
        });
    }

    function $onChanges(changes) {
        if (changes.rsPayoutTransfers) {
            if ((vm.pageNumber - 1) * vm.pageSize > changes.rsPayoutTransfers.length) {
                vm.pageNumber = 1;
            }
        }
    }

    function getColumn(field) {
        return vm.sortColumns.filter(function (column) {
            return column.field === field;
        })[0];
    }

    function onSetSort(sortField) {
        // TODO: Refactor or use an existing library to handle data table functionality.
        let sortColumn = vm.sortColumns.filter(function (sortColumn) {
            return sortColumn.field === sortField.field;
        })[0];
        if (!sortColumn) {
            // Start dir at -1 (descending) so that it toggles to ascending order by default.
            sortColumn = { field: sortField.field, dir: -1 };
            vm.sortColumns.splice(0, vm.sortColumns.length);
            vm.sortColumns.unshift(sortColumn);
        }
        sortColumn.dir *= -1;
        vm.sortTransfers(vm.rsPayoutTransfers);

    }

    function sortTransfers(transfers) {

        return transfers.sort(function (a, b) {
            return vm.sortColumns.reduce(function (comparison, column) {
                // Go through all columns in order and return the value
                // of the first comparison that broke equality (ie, returned non-0).
                if (comparison === 0) {
                    // Still equal.
                    if (a[column.field] < b[column.field]) {
                        return -1 * column.dir;
                    } else if (a[column.field] > b[column.field]) {
                        return column.dir;
                    }
                }
                return comparison;
            }, 0);
        })
    }

    function isSortingByField(field) {
        const column = getColumn(field);
        return !!column;
    }

    function columnClass(field) {
        const column = getColumn(field);
        if (!column) {
            return {};
        }

        return {
            'glyphicon fas fa-sort-amount-down-alt': column.dir > 0,
            'glyphicon fas fa-sort-amount-down': column.dir < 0
        };
    }

    function resetTransfer(transfer) {
        transfer.Amount = vm.selected.Amount * -1;
        vm.selected = {};
        transfer.editMode = false;
    }

    function editTransfer(transfer) {

        if (vm.selected) {

            vm.rsPayoutTransfers.forEach(function (transfer) {
                if (transfer.editMode) {
                    transfer.editMode = false;
                    transfer.Amount = vm.selected.Amount * -1;
                }

            });
        }
        transfer.Amount = Math.abs(transfer.Amount);
        vm.selected = angular.copy(transfer);
        transfer.editMode = true;

    }

    function updateTransfer(transfer) {
        transfer.editMode = false;
        //update when there is a change in amount
        if (Math.abs(transfer.Amount) !== Math.abs(vm.selected.Amount)) {
            utilityService.showLoading();
            rsPayoutTransfersService.updateRSPayoutTransfer(transfer.RSPayoutTransferID, transfer)
                .catch(function (ex) {
                    console.error(ex);
                    alert("Delete failed: " + utilityService.getExceptionMessage(ex));
                    utilityService.hideLoading();
                })
                .then(function () {
                    location.reload();
                });
        } else {
            transfer.Amount *=-1;
        }
    }

    function deleteTransfer(transfer) {
        transfer.editMode = false;
        utilityService.showLoading();
        rsPayoutTransfersService.deleteRSPayoutTransfer(transfer.RSPayoutTransferID)
            .catch(function (ex) {
                console.error(ex);
                alert("Save failed" + utilityService.getExceptionMessage(ex));
                utilityService.hideLoading();
            })
            .then(function () {
                location.reload();
            });

    }

    function onChangeAmount (transfer) {
        transfer.Amount = Math.abs(transfer.Amount);
    }

}
